module.exports = __webpack_public_path__ + "static/media/TriviaPotter.e8474f22.png";